import { Button, makeStyles } from "@material-ui/core";

import palette from "src/styles/palette";

const useStyles = makeStyles(() => ({
  background: {
    background: palette.darkBlue
  }
}));

export default function SaveFieldButton({
  onClick,
  disabled
}: {
  onClick: () => any;
  disabled?: boolean;
}): JSX.Element {
  const classes = useStyles();
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant="contained"
      color="primary"
      className={classes.background}
      disableElevation
    >
      Save
    </Button>
  );
}
